import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {LangChange} from '../../../../../../lang-change';
import {Utils} from '../../../../../../common/services/Utils';
import {EnrollCabinet} from '../../../model/enroll-cabinet';
import {MatDialog} from '@angular/material';
import {Language} from '../../../../../../common/models/language';
import {Principal} from '../../../../../../common/services/principal';
import {QualificationsService} from '../../../../services/qualifications.service';
import {PaymentFormService} from '../../../../../../common_services/payment-form.service';
import {CollegeRegionService} from '../../../../../common-main/services/college-region.service';
import {AlternativeCollegesService} from '../../../../services/alternative-colleges.service';
import {AlternativeCollegeItem} from './model/alternative-college-item';
import {CenterCollegeService} from 'app/common_services/center-college.service';
import {CenterProfessionService} from '../../../../../../common_services/center-profession.service';
import {Router} from '@angular/router';
import {ProfessionService} from '../../../../../../common_services/profession.service';
import {DictionaryService} from '../../../../../shared/services/dictionary.service';
import {CenterSpecialization} from '../../../../../../common/dtos/center-specialization';
import {AdmissionSubjectTypeEnum} from '../../../../../shared/components/dictionary/subject-for-admission-list/admission-subject-type.enum';
import {ExamsSubjectsBalls} from '../../../model/edu-info/exams-subjects-balls';
import {FileServiceModerator} from '../../../../../moderator/services/file-service-moderator.service';
import {AdmissionService} from '../../../../../shared/services/admission.service';
import {FileService} from '../../../../../shared/services/file.service';
import {CenterSpecializationService} from '../../../../../shared/services/center-specialization.service';
import {CollegeInfoService} from '../../../../../common-main/services/college-info.service';
import {EnrollApplicationService} from '../../../../../common-main/services/enroll-application.service';
import {Observable} from 'rxjs/Observable';
import {ApplicantStatusEnum} from '../../../../../../common/enums/applicant-status.enum';
import {ParticipateInRanging} from '../../../../../../common/enums/participate-in-ranging.enum';
import {PaymentForm} from '../../../../../../common/enums/payment-form.enum';
import {EnrollCommissionDecisionService} from '../../../../services/enroll-commission-decision.service';

class AlternativeCollegesSubject {
  mandatory_subjects: any[] = [];
  profile_subjects: any[] = [];
}
/*
declare const $: any;
*/

@Component({
  selector: 'app-enroll-entrans-info',
  templateUrl: './enroll-entrans-info.component.html',
  styleUrls: ['./enroll-entrans-info.component.scss']
})

export class EnrollEntransInfoComponent extends LangChange implements OnInit, OnChanges {
  maxFileSize = 5012000;
  qualifications: CenterSpecialization[];
  grantTypeList: any[] = [];
  alternativeCollegesDictionary: any[] = [];
  alternativeCollegesProfessions: any[] = [];
  alternativeCollegesQualificationArrays: any[] = [];
  alternativeCollegesStudyforms: any[] = [];
  alternativeCollegesInfo: any[] = [];
  mainCollegeInfo: any;
  alternativeCollegesSubjects: AlternativeCollegesSubject[] = [];
  user: any = [];
  setAlternativeColleges = false;
  colleges: any[] = [];
  professions: any[] = [];
  altCollegesIds: any[] = [];
  selectedCollegesMap: Map<number, number[]> = new Map();
  subjectIds = {
    profile_subjects: [],
    mandatory_subjects: []
  };

  subjectsBallsCount: any = null;
  numberOfSubjectForAdmissionSettings: any = {};
  creativeExamProvided = false;
  currentProfessionType = 0;
  PaymentForm = PaymentForm;
  ApplicantStatusEnum = ApplicantStatusEnum;
  rangingPastByQualification = false;

  constructor(public _principal: Principal,
              private dialog: MatDialog,
              public utils: Utils,
              private _route: Router,
              private _paymentFormService: PaymentFormService,
              private _qualificationsService: QualificationsService,
              private _centerSpecializationService: CenterSpecializationService,
              private _collegeRegionService: CollegeRegionService,
              private _alternativeCollegesService: AlternativeCollegesService,
              private _centerCollegeService: CenterCollegeService,
              private _collegeInfoService: CollegeInfoService,
              private _professionService: ProfessionService,
              private _centerProfessionService: CenterProfessionService,
              private fileModeratorService: FileServiceModerator,
              private _enrollApplicationService: EnrollApplicationService,
              private _admissionService: AdmissionService,
              private fileService: FileService,
              private _dictionaryService: DictionaryService,
              private _commissionDecisionService: EnrollCommissionDecisionService) {
    super(utils._translateService);
  }

  @Input() public data: EnrollCabinet;
  @Input() public dics: any;
  @Input() public isTechSecretary: boolean;
  @Input() public isUniversityWorker: boolean;
  @ViewChild('photoFileInput') fileInputVariable;
  @Input() public applicationFormDisabled: boolean;
  @Input() public isCanBeTransfer: boolean;
  @Input() public alternativeColleges: AlternativeCollegeItem[];
  @Output() sendToParent = new EventEmitter();
  @Output() changeCabinetFunction: EventEmitter<any> = new EventEmitter();
  @Input() public applicationStatus: any;
  @Input() public receptionStatus: any;
  @Input() events: Observable<void>;
  @Input() actualizeData = false;

  onLangChange(language: Language): void {
  }

  ngOnInit() {
    this.user = this._principal.getUser();
    if (this.data.entrance_info) {
      if (this.data.entrance_info.speciality) {
        this.loadQualification(null);
        this.loadCenterProfessionInfo();
      }

      // if (!this._principal.isEnroll()) {
        if (this.data.entrance_info.payment_form) {
          this.loadGrantType(null);
        }
      // }
    }
    this.loadAdmissionSubjects();
    this.loadEnrollAlternativeColleges(true);
    // this.loadCenterProfession();
    this.getColleges(null);
    this.loadMainCollegeGSProfessionPlaceCountInfo();
    this.events.subscribe(() => this.loadEnrollAlternativeColleges(true));

    if (this.data.entrance_info && this.data.entrance_info.submissionDate) {
      this.data.entrance_info.submissionDate = new Date(this.data.entrance_info.submissionDate);
    }

    this.dics.inRangingItems = [
      {id: ParticipateInRanging.NOT_DETERMINED, nameRu: 'Не определено', nameKz: 'Анықталмаған', nameEn: 'Not determined', name: '0'},
      {id: ParticipateInRanging.YES, nameRu: 'Да', nameKz: 'Ия', nameEn: 'Yes', name: '1'},
      {id: ParticipateInRanging.NO, nameRu: 'Нет', nameKz: 'Жоқ', nameEn: 'No', name: '2'}
    ];
    Language.updateListLocalizedName(this.dics.inRangingItems);
    // this.data.entrance_info.inRanging = 0;
    this._commissionDecisionService.rangingPastByQualification(this.data.edu_info.edu_received, this.data.entrance_info.qualification).subscribe(data => {
      this.rangingPastByQualification = data.data;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.actualizeData && changes.actualizeData.currentValue) {
      this._sendToParent();
    }
  }

/*
  ngAfterViewInit() {
    $('#decidedByComission').prop('disabled', false);
  }
*/

  getCode(id: number) {
    return this.dics.professions.find(profession => profession.id === id).code;
  }

  getQualificationCode(id: number) {
    if (!id || this.qualifications.length == 0) return '';
    return this.qualifications.find(q => q.id === id).code;
  }

  loadQualification(event) {
    if (event) {
      this.data.entrance_info.qualification = 0;
      this.qualifications = [];
    }
    // console.log('data.entrance_info.speciality', this.data.entrance_info.speciality);
    if (!!this.data && this.data.entrance_info.speciality > 0) {
      const filter = {
        centerProfessionId: this.data.entrance_info.speciality,
        educatedId: this.data.edu_info.edu_received,
        studylanguageId: this.data.entrance_info.learn_lang,
        isUsedInGrant: true,
        status: 5,
        year: new Date().getFullYear()
      };
      if (this.data.entrance_info.payment_form === 2) {
        this._enrollApplicationService.getCenterSpecializations(filter).subscribe(data => {
          this.qualifications = data;
          Language.updateListLocalizedName(this.qualifications);
          this.qualifications.map((i) => {
            i.name = i.code + ' ' + i.name;
            return i;
          });
        });
      } else if(this.data.entrance_info.payment_form === 1){
        this._enrollApplicationService.getCenterSpecializationsByProfId(filter).subscribe(data => {
          this.qualifications = data;
          Language.updateListLocalizedName(this.qualifications);
          this.qualifications.map((i) => {
            i.name = i.code + ' ' + i.name;
            return i;
          });
        });
      }
    }
  }

  paymentFormChanged(event) {
    this.loadGrantType(event);
    this.studyLanguageChanged();
    this.changeQuota();
    if (this.data.entrance_info.payment_form == 2) {
      this.data.entrance_info.department_id = 1;
      this.data.entrance_info.inRanging = ParticipateInRanging.NOT_DETERMINED;
      if (this.alternativeColleges && this.alternativeColleges.length > 0) {
        this.alternativeColleges.forEach(c => c.inRanging = ParticipateInRanging.NOT_DETERMINED);
      }
    }
  }

  changeQuota(){
    if (this.data.edu_info.edu_institute_place == 2 && this.data.entrance_info.payment_form == 2 &&
      (this.data.quota.quotaid == 0 || this.data.quota.quotaid == undefined)){
      this.data.quota.quotaid = 3;
    } else if((this.data.edu_info.edu_institute_place == 1 || this.data.entrance_info.payment_form == 1)
      && this.data.quota.quotaid == 3){
      this.data.quota.quotaid = 0;
    }
  }


  loadGrantType(event) {
    if (event) {
      this.data.entrance_info.grant_type = null;
    }

    this._paymentFormService.getGrantTypes(this.data.entrance_info.payment_form).subscribe(data => {
      this.grantTypeList = data;
      if (this.data.entrance_info.payment_form === 1) {
        this.data.entrance_info.grant_type = -7;
      } else {
        this.data.entrance_info.grant_type = -8;
      }
    });
  }

  loadEnrollAlternativeColleges(onInit) {
    this._collegeRegionService.getCollegeRegionInfo().subscribe(value => {
      if (value) {
        this.dics.authority = value['collegeRegionInfo'];
        if (!!this.dics.authority.alternativelyEduCount && this.dics.authority.alternativelyEduCount > 0) {
          this.alternativeColleges = [];
          if (onInit) {
            this._alternativeCollegesService.getAlternativeCollegesByEnrollId(this.data.enrollId).subscribe(value => {
              if (!!value && !!value['data']) {
                if (onInit) {
                  this.setAlternativeColleges = true;
                }
                this.alternativeColleges = value['data'];
                if ((this.alternativeColleges.length - 1) < this.dics.authority.alternativelyEduCount) {
                  const cnt = this.dics.authority.alternativelyEduCount - (this.alternativeColleges.length - 1);
                  for (let i = 0; i < cnt; i++) {
                    this.alternativeColleges.push(new AlternativeCollegeItem(1));
                  }
                }
                this.fillAltCollegesIds();
                for (let i = 0; i < this.alternativeColleges.length; i++) {
                  this.loadQualificationForAlternativeCollege(null, i);
                  this.loadCollegesForAlternativeCollege2(null, i);
                  this.loadGSProfessionPlaceCountInfo(null, i);
                  this.loadSubjectsForAlternativeCollege(i, 'mandatory_subjects');
                  this.loadSubjectsForAlternativeCollege(i, 'profile_subjects');
                  this.loadNumberOfSubjectForAdmissionListByYearForAlternative(i);
                  // this.loadSubjectsForAlternativeCollege(i, 'profile_subjects');
                  // this.loadProfessionsForAlternativeCollege(null, i);
                  // this.loadStudyformsForAlternativeCollege(null, i);
                }
                this._sendToParent();
              }
            });
          } else {
            if (this.setAlternativeColleges) {
              for (let i = 1; i <= this.dics.authority.alternativelyEduCount; i++) {
                this.alternativeColleges.push(new AlternativeCollegeItem(i));
                this.alternativeCollegesProfessions.push([]);
                this.alternativeCollegesQualificationArrays.push([]);
                this.alternativeCollegesInfo.push([]);
                // this.loadSubjectsForAlternativeCollege(i, 'mandatory_subjects');
                this.loadNumberOfSubjectForAdmissionListByYearForAlternative(i - 1);
                this._sendToParent();
              }
            }
          }
        }
      }
    });
  }

  fillAltCollegesIds() {
    this.selectedCollegesMap = new Map();
    if (this.data.entrance_info.speciality > 0 && this.data.collegeId > 0) {
      this.selectedCollegesMap.set(this.data.entrance_info.speciality, [this.data.collegeId]);
    }
    this.alternativeColleges.forEach(ac => {
      if (!ac.sourceCollege && ac.active) {
        if (ac.specId > 0 && ac.collegeId > 0) {
          if (this.selectedCollegesMap.has(ac.specId)) {
            this.selectedCollegesMap.get(ac.specId).push(ac.collegeId);
          } else {
            this.selectedCollegesMap.set(ac.specId, [ac.collegeId]);
          }
        }
      }
    });
  }

  loadCollegesForAlternativeCollege(event, i) {
    this.fillAltCollegesIds();
    this._sendToParent();
    this.alternativeColleges.forEach((a, index) => {
      const arr = [];
      this.colleges.forEach(col => {
        arr.push({id: col.id, name: col.name, disabled: (this.altCollegesIds.indexOf(col.id) > -1)});
      });
      if (!!i) {
        this.alternativeCollegesDictionary[index] = [];
        this.alternativeCollegesDictionary[index] = arr;
      } else {
        this.alternativeCollegesDictionary.push(arr);
      }
    })
  }

  loadStudyformsForAlternativeCollege(event, i) {
    this._sendToParent();
    if (event) {
      this.alternativeCollegesStudyforms[i] = [];
      this.alternativeColleges[i].studyformId = null;
    }

    if (!!this.alternativeColleges[i].collegeId) {

      this._dictionaryService.getStudyFormsList(this.alternativeColleges[i].collegeId).subscribe(data => {
          data = data.filter( h => h.id !== 1 && h.id !== 2); // удаляем записи "Дневная" и "Заочная"
        this.alternativeCollegesStudyforms[i] = this.utils.translateListWithSort(data, 'name');
        }, err => { console.log('EnrollEntransInfoComponent _dictionaryService.getStudyFormsList() error', err);
          this.utils.notifyError(this._translateService.instant('error_occurred'), '');
        }
      );
    } else {
      this.alternativeCollegesStudyforms[i] = [];
    }
  }

  // loadProfessionsForAlternativeCollege(event, i) {
  //   for (let ic = 0; ic < this.alternativeColleges.length; ic++) {
  //     this.loadCollegesForAlternativeCollege(null, ic);
  //   }
  //   this._sendToParent();
  //   if (event) {
  //     this.alternativeCollegesProfessions[i] = [];
  //     this.alternativeColleges[i].specId = null;
  //   }
  //   if (!!this.alternativeColleges[i].collegeId) {
  //     this._professionService.getAlternativeProfessionListByCode(this.alternativeColleges[i].collegeId, this.data.edu_info.edu_received,
  //       2020, this.getCode(this.data.entrance_info.speciality)).subscribe(data => {
  //           this.alternativeCollegesProfessions[i] = this.utils.translateListWithSort(data, 'name');
  //           this.alternativeCollegesProfessions[i].map((i) => {
  //             i.fullName = i.code + ' ' + i.name;
  //             return i;
  //           });
  //       }, err => { console.log('EnrollEntransInfoComponent _professionService.getAlternativeProfessionListByCode error', err);
  //         this.utils.notifyError(this._translateService.instant('error_occurred'), '');
  //       }
  //     );
  //   } else {
  //     this.alternativeCollegesProfessions[i] = [];
  //   }
  // }

  alternativeCollegeProfessionChanged(event, i) {
    this.alternativeCollegesQualificationArrays[i] = [];
    this.alternativeColleges[i].qualificationId = 0;
    this.alternativeCollegesDictionary[i] = [];
    this.alternativeColleges[i].collegeId = 0;
    this.alternativeCollegesInfo[i] = [];
    this.alternativeColleges[i].entrance_exams_info.gpa = 0;
    this.resetData(this.alternativeColleges[i].entrance_exams_info.profile_subjects);
    this.resetData(this.alternativeColleges[i].entrance_exams_info.mandatory_subjects);

    this.loadQualificationForAlternativeCollege(event, i);

    this._centerProfessionService.getById(this.alternativeColleges[i].specId).subscribe(data => {
      this.alternativeColleges[i].specialExamProvided = data.specialExamProvided;
    });
  }

  resetData(subjects) {
    subjects.forEach(subject => {
      subject.subjectId = null;
      subject.points = 0;
      if (subject.subject) {
        subject.subject = null;
      }
    });
  }

  loadQualificationForAlternativeCollege(event, i) {
    this._sendToParent();
    this.loadSubjectsForAlternativeCollege(i, 'mandatory_subjects');
    this.loadSubjectsForAlternativeCollege(i, 'profile_subjects');
    // this.loadCollegesForAlternativeCollege2(event, i);

    if (this.alternativeColleges[i].specId > 0) {
      const filter = {
        centerProfessionId: this.alternativeColleges[i].specId,
        educatedId: this.data.edu_info.edu_received,
        studylanguageId: this.data.entrance_info.learn_lang,
        isUsedInGrant: true,
        status: 5,
        year: new Date().getFullYear()
      };
      this._enrollApplicationService.getCenterSpecializations(filter).subscribe(data => {
        const code = this.getQualificationCode(this.data.entrance_info.qualification);
        if (code.toString().toUpperCase().indexOf('W') == -1) {
          this.alternativeCollegesQualificationArrays[i] = data.filter(q => q.code.toString().toUpperCase().indexOf('W') == -1);
        }
        Language.updateListLocalizedName(this.alternativeCollegesQualificationArrays[i]);
        this.alternativeCollegesQualificationArrays[i].map((i) => {
          i.fullName = i.code + ' ' + i.name;
          return i;
        });
        this.alternativeCollegesQualificationArrays[i] = this.utils.translateListWithSort(this.alternativeCollegesQualificationArrays[i], 'code');
      });
    } else {
      this.alternativeCollegesQualificationArrays[i] = [];
    }

  }

  alternativeCollegeQualificationChanged(event, i) {
    this.alternativeCollegesDictionary[i] = [];
    this.alternativeColleges[i].collegeId = null;
    this.alternativeCollegesInfo[i] = [];

    this.loadCollegesForAlternativeCollege2(event, i);
  }

  loadCollegesForAlternativeCollege2(event, i) {
    this.fillAltCollegesIds();
    if (this.alternativeColleges[i].specId > 0 && this.alternativeColleges[i].qualificationId > 0) {
      this._collegeInfoService
        .getCollegesWithGrant(this.alternativeColleges[i].specId, this.alternativeColleges[i].qualificationId,
          this.data.edu_info.edu_received, this.data.entrance_info.learn_lang, this.utils._translateService.currentLang, this.data.entrance_info.payment_form)
        .subscribe(data => {
          this.alternativeCollegesDictionary[i] = data['colleges'];
          this.loadDisabledColleges();
      });
    } else {
      this.alternativeCollegesDictionary[i] = [];
    }
  }

  loadDisabledColleges() {
    this.fillAltCollegesIds();
    for (let i = 0; i < this.alternativeColleges.length; i++) {
      if (!this.alternativeColleges[i].sourceCollege && this.alternativeColleges[i].active) {
        if (this.alternativeCollegesDictionary[i]) {
          const arr = [];
          const selectedCollegeIds = this.selectedCollegesMap.get(this.alternativeColleges[i].specId) || [];
          this.alternativeCollegesDictionary[i].forEach(col => {
            arr.push({id: col.id, name: col.name, disabled: (selectedCollegeIds.indexOf(col.id) > -1)});
          });
          this.alternativeCollegesDictionary[i] = arr;
        }
      }
    }

    const tmpColleges = [];
    const tmpSelectedCollegeIds = this.selectedCollegesMap.get(this.data.entrance_info.speciality) || [];
    this.colleges.forEach(col => {
      tmpColleges.push({id: col.id, name: col.name, disabled: (tmpSelectedCollegeIds.indexOf(col.id) > -1)});
    });
    this.colleges = tmpColleges;
  }

  setAlternativeCollegesChanged($event) {
    // если галочка с чекбокса убрана то в парент отправляем пустой массив, если поставлена то массив с альт. колледжами
    if ($event) {
      if (this.setAlternativeColleges) {
        this.loadEnrollAlternativeColleges(false);
      } else {
        this.selectedCollegesMap = new Map();
        this.sendToParent.emit({alternativeColleges: [], setAlternativeColleges: this.setAlternativeColleges});
      }
    }
  }

  _sendToParent() {
    this.sendToParent.emit({alternativeColleges: this.alternativeColleges, setAlternativeColleges: this.setAlternativeColleges,
      alternativeCollegesDictionary: this.alternativeCollegesDictionary,
      alternativeCollegesProfessions: this.dics.alternativeCollegeProfessions,
      alternativeCollegesQualificationArrays: this.alternativeCollegesQualificationArrays,
      mainCollegeNamesDic: this.colleges,
      mainCollegeProfessions: this.dics.professions,
      mainCollegeSpecializations: this.qualifications });
  }

  log(e) {
    console.info('_______ LOG', e);
  }

  getElementById(arr: any[], id, prop):any {
    if (!arr && arr.length < 1) {
      return null;
    }
    const ret = arr.filter(e => e.id === id);
    if (ret.length > 0 && !!ret[0][prop]) {
      return ret[0][prop];
    }
    return '-';
  }

  // перевод абитуриента в др колледж
  transferToAlternativeCollege(altCollege: AlternativeCollegeItem, i: number) {
    const altCollegeName = this.alternativeCollegesDictionary[i].filter(e => e.id === altCollege.collegeId);// находим название колледжа куда переводится
    const currCollegeName = this.colleges.filter(e => e.id === this.data.collegeId);// находим название колледжа откуда переводится
    if (altCollegeName && currCollegeName) { // если нашли оба названия
      this.utils.confirmDialog( // вывод предупреждения
        {message: 'enroll_cabinet_page.entrance_info_tab.alternative_colleges_for_entrance.transfer_confirm',
          messageParams: {alternativeCollegeName: altCollegeName[0].name, currentCollegeName: currCollegeName[0].name }}, () => {
          // получили подтверждение
          // предварительно сохраняем все альтернативные колледжи
          this._alternativeCollegesService.saveAlternativeColleges(this.alternativeColleges, this.data.enrollId).subscribe( value => {
            if(value && value['data']) {// получили ответ от сохранения
              if (value['status'] === "SUCCESS") { // ответ положительный
                // переводим абитуриента
                this._alternativeCollegesService.transferEnrollToAlternativeCollege(altCollege, this.data.enrollId).subscribe(value => {
                  if(value && value['data']) {// получили ответ от сохранения
                    if (value['status']=== "SUCCESS") {// ответ успешный
                      this.alternativeColleges = value['data']; // присваеваем массив альт колледжей из ответа
                       let enrollFullName = this.data.personal_info.surname + ' ' + this.data.personal_info.firstname + ' ' + this.data.personal_info.patronymic;
                        this._translateService.get('enroll_cabinet_page.entrance_info_tab.alternative_colleges_for_entrance.transfer_success_message',{enrollName: enrollFullName, collegeName: altCollegeName[0].name})
                          .subscribe(translation => {
                          alert(translation); // выводим алерт об успешном переводе
                        });
                      this._route.navigate(['user/requests/enrolle/']);// уходим на страницу со списком абитуриентов
                    } else { // ответ не успешный, выводим сообщение об ошибке и пишем в консоль
                      this.notifyError(null, {'ERROR! transferEnrollToAlternativeCollege: ': value['data']});
                    }
                  }
                }, error => {// ошибка, выводим сообщение об ошибке и пишем в консоль
                  this.notifyError(null, {'ERROR! transferEnrollToAlternativeCollege: ': error});
                });

              } else {// ошибка, выводим сообщение об ошибке и пишем в консоль
                this.notifyError(null, {'ERROR! saveAlternativeColleges: ': value['data']});
              }
            }
          }, error => {// ошибка, выводим сообщение об ошибке и пишем в консоль
            this.notifyError(null, {'ERROR! saveAlternativeColleges: ': error});
          });

        });
    } else {// ошибка, выводим сообщение об ошибке и пишем в консоль
      this.notifyError(null, 'По указанным id альтернативного колледжа или id текущего колледжа не удалось найти описание из справочника!');
      console.error('transferToAlternativeCollege', altCollege);
    }

  }

  notifyError(disc, log) {
    this.utils.notifyError(disc, null);
    console.error('ERROR! notifyError: ', log);
  }

  studyLanguageChanged() {
    this.data.entrance_info.speciality = 0;
    this.data.entrance_info.qualification = 0;
    this.data.collegeId = 0;
    this.changeCabinetFunction.emit({functionName: 'loadCenterProfession'});
    this.changeCabinetFunction.emit({functionName: 'resetAlternativeColleges'});
  }
  fillSubjectIds(entOrExamProp, subjectProp) {
    this.subjectIds[subjectProp] = [];
    this.data.edu_info[entOrExamProp][subjectProp].forEach(subject => {
      this.subjectIds[subjectProp].push(subject.subjectId);
    });
  }
  /* Тип поступления */
  loadDisabledSubjects(entOrExamProp, subjectProp) {
    this.fillSubjectIds(entOrExamProp, subjectProp);
    this.dics[subjectProp].forEach(subject => {
      subject.disabled = (this.subjectIds[subjectProp].indexOf(subject.id) > -1);
    });
  }

  loadSubjectsForAlternativeCollege(i, subjectProp) {
    this.alternativeCollegesSubjects[i] = new AlternativeCollegesSubject();
    const graduateForeign = this.data.edu_info.edu_institute_country != 113;
    const loadProfileSubjects = this.data.edu_info.edu_institute_graduate == 2 && this.data.edu_info.type_of_admission == 1;
    if (this.alternativeColleges[i]) {
      const ttype = AdmissionSubjectTypeEnum.getSubjectType(graduateForeign ? 'profile_subjects' : subjectProp, this.data.edu_info.edu_received);
      const entYear = new Date().getFullYear();
      const centerProfessionId = this.alternativeColleges[i].specId;
      if (ttype && entYear && centerProfessionId > 0) {
        this._dictionaryService.getAdmissionSubjectListByProfessionAndTypeAndYear(ttype, entYear, (graduateForeign || loadProfileSubjects ? 0 : centerProfessionId)).subscribe(resp => {
          this.alternativeCollegesSubjects[i][subjectProp] = resp;
          if (loadProfileSubjects || graduateForeign) {
            this.alternativeCollegesSubjects[i][subjectProp] = resp.filter(s => s.creativeExam != true);
          }
          for (let j = 0; j < resp.length; j++) {
            resp[j].ballList = [];
            if (resp[j].maxPoints) {
              for (let v = resp[j].minPoints; v <= resp[j].maxPoints; v++) {
                resp[j].ballList.push(v);
              }
            }
            const items = this.alternativeColleges[i].entrance_exams_info[subjectProp].filter(s => s.subjectId == resp[j].id);
            if (items && items.length) {
              items[0].subject = resp[j];
            }
          }

        });
      }
    }

  }

  initSubjects(entOrExamProp, subjectProp) {
    const graduateForeign = this.data.edu_info.edu_institute_country != 113;
    const loadProfileSubjects = this.data.edu_info.edu_institute_graduate == 2 && this.data.edu_info.type_of_admission == 1;
    const ttype = AdmissionSubjectTypeEnum.getSubjectType(graduateForeign ? 'profile_subjects' : subjectProp, this.data.edu_info.edu_received);
    const entDate = this.data.edu_info.ent_kt_serificate_info.ent_kt_serificate_give_date;
    const entYear = entDate > 0 ? new Date(entDate).getFullYear() : new Date().getFullYear();
    const centerProfessionCodeId = this.data.entrance_info.speciality;
    if (ttype && entYear && centerProfessionCodeId > 0) {
      this._dictionaryService.getAdmissionSubjectListByProfessionAndTypeAndYear(ttype, entYear, (graduateForeign || loadProfileSubjects ? 0 : centerProfessionCodeId)).subscribe(resp => {
        this.dics[subjectProp] = resp;
        if (loadProfileSubjects || graduateForeign) {
          this.dics[subjectProp] = resp.filter(s => s.creativeExam != true);
        }
        if (subjectProp == 'profile_subjects') {
          this.creativeExamProvided = resp.filter(s => s.creativeExam).length > 0;
        }
        this.data.edu_info[entOrExamProp][subjectProp] = this.data.edu_info[entOrExamProp][subjectProp] || [];
        for (let i = 0; i < resp.length; i++) {
          resp[i].ballList = [];
          if (resp[i].maxPoints) {
            for (let v = resp[i].minPoints; v <= resp[i].maxPoints; v++) {
              resp[i].ballList.push(v);
            }
          }
          const items = this.data.edu_info[entOrExamProp][subjectProp].filter(s => s.subjectId == resp[i].id);
          if (items && items.length) {
            items[0].subject = resp[i];
          } else {
            // if (this.data.edu_info[entOrExamProp][subjectProp].length < 2) {
            //   this.data.edu_info[entOrExamProp][subjectProp].push({subjectId: resp[i].id, subject: resp[i], enrollId: this.data.enrollId});
            // }
          }
        }
        this.loadDisabledSubjects(entOrExamProp, subjectProp);
      });
    }
  }

  loadNumberOfSubjectForAdmissionListByYear() {
    this._admissionService.getNumberOfSubjectForAdmissionListByYear(new Date().getFullYear()).subscribe(data => {
      if (!!data && !!data.dtoList[0]) {
        this.numberOfSubjectForAdmissionSettings = data.dtoList[0];
      }
      this.editMandatorySubjectsToNumberOfSubjects();
    }, error => {
      this.utils.notifyError(this._translateService.instant('error_occurred'), null);
      console.error('_admissionService.getNumberOfSubjectForAdmissionListByYear ERROR!', error)
    });
  }
  loadNumberOfSubjectForAdmissionListByYearForAlternative(i) {
    this._admissionService.getNumberOfSubjectForAdmissionListByYear(new Date().getFullYear()).subscribe(data => {
      if (!!data && !!data.dtoList[0]) {
        this.numberOfSubjectForAdmissionSettings = data.dtoList[0];
      }
      this.editMandatorySubjectsToNumberOfSubjectsForAlternative(i);
    }, error => {
      this.utils.notifyError(this._translateService.instant('error_occurred'), null);
      console.error('_admissionService.getNumberOfSubjectForAdmissionListByYear ERROR!', error)
    });
  }

  editMandatorySubjectsToNumberOfSubjects() {
    let requiredSubjectsNumber = this.getRequiredSubjectsCount('mandatory_subjects');
    let profileSubjectsNumber = this.getRequiredSubjectsCount('profile_subjects');
    if (this.data.edu_info.edu_institute_country !== 113) {
      profileSubjectsNumber = requiredSubjectsNumber + profileSubjectsNumber;
      requiredSubjectsNumber = 0;
    }
    this.data.edu_info.entrance_exams_info.mandatory_subjects = this.getRequiredSubjects(requiredSubjectsNumber, this.data.edu_info.entrance_exams_info.mandatory_subjects);
    this.data.edu_info.entrance_exams_info.profile_subjects = this.getRequiredSubjects(profileSubjectsNumber, this.data.edu_info.entrance_exams_info.profile_subjects);
    this.getSubjectsBallsCount('entrance_exams_info');
  }

  editMandatorySubjectsToNumberOfSubjectsForAlternative(i) {
    let requiredSubjectsNumber = this.getRequiredSubjectsCount('mandatory_subjects');
    let profileSubjectsNumber = this.getRequiredSubjectsCount('profile_subjects');
    if (this.data.edu_info.edu_institute_country !== 113) {
      profileSubjectsNumber = requiredSubjectsNumber + profileSubjectsNumber;
      requiredSubjectsNumber = 0;
    }
    this.alternativeColleges[i].entrance_exams_info.mandatory_subjects = this.getRequiredSubjects(requiredSubjectsNumber, this.alternativeColleges[i].entrance_exams_info.mandatory_subjects);
    this.alternativeColleges[i].entrance_exams_info.profile_subjects = this.getRequiredSubjects(profileSubjectsNumber, this.alternativeColleges[i].entrance_exams_info.profile_subjects);
    this.getSubjectsBallsCountForAlternative(i);
  }

  getRequiredSubjectsCount(type) {
    if (this.numberOfSubjectForAdmissionSettings) {
      if (type === 'mandatory_subjects') {
        switch (this.data.edu_info.edu_received) {
          case 1: return this.numberOfSubjectForAdmissionSettings.requiredSubjects_9_10;
          default: return this.numberOfSubjectForAdmissionSettings.requiredSubjects_11_12;
        }
      } else if (type == 'profile_subjects') {
        switch (this.data.edu_info.edu_received) {
          case 1: return this.numberOfSubjectForAdmissionSettings.profileSubjectAdmission_9_10;
          default: return this.numberOfSubjectForAdmissionSettings.profileSubjectAdmission_11_12;
        }
      }
    }
    return 0;
  }

  getRequiredSubjects(requiredSubjectsNumber, initialSubjects) {
    const ret: any[] = [];
    for (let i = 0; i < requiredSubjectsNumber; i++) {
      if (initialSubjects[i]) {
        ret.push(initialSubjects[i]);
      } else {
        ret.push(new ExamsSubjectsBalls());
      }
    }
    return ret;
  }

  loadAdmissionSubjects() {
    if (this.data.edu_info.type_of_admission === 1 || this.data.edu_info.type_of_admission === 2) {
      this.initSubjects('entrance_exams_info', 'mandatory_subjects');
      this.initSubjects('entrance_exams_info', 'profile_subjects');
      this.loadNumberOfSubjectForAdmissionListByYear();
    }
  }

  getCenterProfessionCode(centerProfessionId: number) {
    if (this.dics.centerProfessions) {
      const professions = this.dics.centerProfessions.filter(e => e.id === centerProfessionId);
      if (professions && professions.length) {
        return professions[0].code;
      }
    }
    return null;
  }

  changeAdmissionSubject(admission) {
    if (admission.subject) {
      admission.subjectId = admission.subject.id;
      this.loadDisabledSubjects('entrance_exams_info', 'mandatory_subjects');
      this.loadDisabledSubjects('entrance_exams_info', 'profile_subjects');
    } else {
      admission.subjectId = null;
    }
  }

  getSubjectsBallsCount(prop) {
    this.subjectsBallsCount = 0;
    // if profession is medical count only profile subjects
    this.currentProfessionType = this.dics.professions.find(prof => prof.id === this.data.entrance_info.speciality).professionTypeId;
    let requiredSubjectsNumberSum = this.currentProfessionType == 24 && this.data.edu_info.edu_received == 3 ? this.getRequiredSubjectsCount('profile_subjects')
      : this.getRequiredSubjectsCount('mandatory_subjects') + this.getRequiredSubjectsCount('profile_subjects');
    if (!(this.currentProfessionType == 24 && this.data.edu_info.edu_received == 3)) {
      this.data.edu_info[prop]['mandatory_subjects'].forEach(value => {
        if (value && value.points > -1) {
          this.subjectsBallsCount += value.points;
        }
      });
    }

    this.data.edu_info[prop]['profile_subjects'].forEach(value => {
      if (value && value.points > -1) {
        this.subjectsBallsCount += value.points;
      }
    });
    this.data.edu_info[prop].count_exams_balls = this.subjectsBallsCount;

    if (this.data.entrance_info.specialExamProvided && this.data.entrance_info.specialExamType == 2 && this.data.entrance_info.specialExam) {
      this.subjectsBallsCount += this.data.entrance_info.specialExam;
      requiredSubjectsNumberSum += 1;
      for (let i = 0; i < this.alternativeColleges.length; i++) {
        if (this.alternativeColleges[i].specialExamProvided) {
          this.getSubjectsBallsCountForAlternative(i);
        }
      }
    }
    if (requiredSubjectsNumberSum > 0) {
      this.data.edu_info[prop].gpa = Number((this.subjectsBallsCount / requiredSubjectsNumberSum).toFixed(2));
    }
  }
  getSubjectsBallsCountForAlternative(i) {
    let subjectsBallsCount = 0;
    const currentProfession = this.dics.professions.find(prof => prof.id === this.alternativeColleges[i].specId);
    let currentProfessionType = 0;
    if (currentProfession != undefined) {
      currentProfessionType = currentProfession.professionTypeId;
    }
    let requiredSubjectsNumberSum = currentProfessionType == 24 && this.data.edu_info.edu_received == 3 ? this.getRequiredSubjectsCount('profile_subjects')
      : this.getRequiredSubjectsCount('mandatory_subjects') + this.getRequiredSubjectsCount('profile_subjects');
    if (!(currentProfessionType == 24 && this.data.edu_info.edu_received == 3)) {
      this.alternativeColleges[i].entrance_exams_info.mandatory_subjects.forEach(value => {
        if (value && value.points > -1) {
          subjectsBallsCount += value.points;
        }
      });
    }

    this.alternativeColleges[i].entrance_exams_info.profile_subjects.forEach(value => {
      if (value && value.points > -1) {
        subjectsBallsCount += value.points;
      }
    });
    if (this.data.entrance_info.specialExamProvided && this.data.entrance_info.specialExamType == 2 && this.data.entrance_info.specialExam) {
      if (this.alternativeColleges[i].specialExamProvided) {
        subjectsBallsCount += this.data.entrance_info.specialExam;
        requiredSubjectsNumberSum += 1;
      }
    }
    if (requiredSubjectsNumberSum > 0) {
      this.alternativeColleges[i].entrance_exams_info.gpa = Number((subjectsBallsCount / requiredSubjectsNumberSum).toFixed(2));
    }
    this._sendToParent();
  }

  round(n, f) {
    f = Math.pow(10, -f);
    return Math.round(n / f) * f;
  }


  fileInputChangeEvent(fileInput: any, item: number) {
    if (fileInput.target.files && fileInput.target.files[0]) {
      if (fileInput.target.files[0].size > this.maxFileSize) {
        this.utils.notifyError(this._translateService.instant('enroll_cabinet_page.upload_file_size_exceed'), '');
        return false;
      } else {
        const file: File = fileInput.target.files[0];
        const formData = new FormData();
        formData.append('file', file, file.name);
        this.fileModeratorService.uploadFile(formData).subscribe(res => {
          this.changeDataFile(item, res);
        });
      }
    }
  }

  deleteFile(fileId: any, item: number) {
    this.utils.confirmDialog({message: 'delete_confirmation'}, () => {
      this.fileModeratorService.deleteFile(fileId).subscribe(res => {
        this.changeDataFile(item, null);
      });
    });
  }

  changeDataFile(item: number, data: any) {
    switch (item) {
      case 0:
        this.data.edu_info.edu_doc_scan = data;
        break;
      case 1:
        this.data.edu_info.attestat.attestat_app_scan = data;
        break;
      case 2:
        this.data.edu_info.ent_kt_serificate_info.ent_kt_serificate_scan = data;
        break;
      case 3:
        this.data.edu_info.interview_info.interview_result_mark = data;
        break;
      case 4:
        this.data.edu_info.diplom_info.diplom_scan = data;
        break;
      case 5:
        this.data.edu_info.diplom_info.essay = data;
        break;
      case 6:
        this.data.edu_info.attestat.attestat_scan = data;
        break;
      case 7:
        this.data.edu_info.diplom_info.diplom_app_scan = data;
        break;
    }
  }

  getFile(id: any) {
    this.utils.blockStart(null);
    this.fileService.getFileInfo(id).subscribe((fileInfo) => {
      this.fileService.getFile(fileInfo.fileId).subscribe((data) => {
        this.fileService.downloadPsFile(data, fileInfo);
        this.utils.blockStop();
      });
    });
  }

  professionChanged(event) {
    this.data.collegeId = 0;
    this.data.entrance_info.qualification = 0;
    this.colleges = [];
    this.qualifications = [];
    this.mainCollegeInfo = [];
    this.data.entrance_info.workQualification = false;
     this.resetData(this.data.edu_info.entrance_exams_info.mandatory_subjects);
     this.resetData(this.data.edu_info.entrance_exams_info.profile_subjects);
    this.data.edu_info.entrance_exams_info.gpa = 0;

    this.changeCabinetFunction.emit({functionName: 'resetAlternativeColleges'});
    this.changeCabinetFunction.emit({functionName: 'loadAlternativeCollegeProfessions'});
    // this.sendToParent.emit({alternativeColleges: [], setAlternativeColleges: this.setAlternativeColleges});
    this.loadQualification(event);
    // this.loadAdmissionSubjects();
    this.initSubjects('entrance_exams_info', 'mandatory_subjects');
    this.initSubjects('entrance_exams_info', 'profile_subjects');
    this.loadNumberOfSubjectForAdmissionListByYear();
    this.currentProfessionType = this.dics.professions.find(prof => prof.id === this.data.entrance_info.speciality).professionTypeId;
    this.data.entrance_info.specialExamProvided = false;
    this.data.entrance_info.specialExam = null;
    this.data.entrance_info.specialExamType = null;
  }

  /*loadCenterProfession() {
    const filter = {
      hasCount: true,
      studyLanguageId: this.data.entrance_info.learn_lang,
      educatedId: this.data.edu_info.edu_received
    };
    this._centerProfessionService.getCenterProfessionsWithGrant(filter).subscribe(data => {
        this.professions = this.utils.translateListWithSort(data, 'name');
        this.professions.map((i) => {
          i.fullName = i.code + ' ' + i.name;
          return i;
        });
      }, err => {
        console.log('EnrollCabinetComponent _centerProfessionService.getCenterProfessionsWithGrant() error', err);
        this.utils.notifyError(this._translateService.instant('error_occurred'), '');
      }
    );
  }*/
  loadMainCollegeGSProfessionPlaceCountInfo() {
    if (this.data.entrance_info.speciality > 0) {
      if (!this.data.collegeId || this.data.collegeId == 0) {
        this.data.collegeId = 0;
      }
      const filter = {
        hasCount: true,
        centerProfessionId: this.data.entrance_info.speciality,
        studyLanguageId: this.data.entrance_info.learn_lang,
        college: this.data.collegeId,
        educatedId: this.data.edu_info.edu_received
      };
      this._enrollApplicationService.getGSProfessionPlaceCountInfo(filter).subscribe(data => {
        this.mainCollegeInfo = data;
      });
    }
  }

  alternativeCollegeCollegeChanged(event, i) {
    this.alternativeCollegesInfo[i] = null;
    this.loadGSProfessionPlaceCountInfo(event, i);
  }

  loadGSProfessionPlaceCountInfo(event, i) {
    this.loadDisabledColleges();
    if (this.alternativeColleges[i].specId > 0 && this.alternativeColleges[i].collegeId > 0) {
      const filter = {
        hasCount: true,
        centerProfessionId: this.alternativeColleges[i].specId,
        studyLanguageId: this.data.entrance_info.learn_lang,
        college: this.alternativeColleges[i].collegeId,
        educatedId: this.data.edu_info.edu_received
      };
      this._enrollApplicationService.getGSProfessionPlaceCountInfo(filter).subscribe(data => {
        this.alternativeCollegesInfo[i] = data;
      });
    }
  }

  getColleges($event) {
    if ($event) {
      this.data.collegeId = null;
      this.colleges = [];
    }
    if (this.data.entrance_info.speciality > 0 && this.data.entrance_info.qualification > 0 && this.data.entrance_info.payment_form > 0)  {
      this._collegeInfoService.getCollegesWithGrant(this.data.entrance_info.speciality,
        this.data.entrance_info.qualification, this.data.edu_info.edu_received, this.data.entrance_info.learn_lang, this.utils._translateService.currentLang, this.data.entrance_info.payment_form).subscribe(
        response => {
          this.colleges = response['colleges'];
          this.loadDisabledColleges();
        },
        error => console.log(error)
      );
    }
  }

    qualificationChanged($event) {
      this.data.entrance_info.workQualification = this.getQualificationCode(this.data.entrance_info.qualification).toString().toUpperCase().indexOf('W') > -1;
      if (this.data.entrance_info.workQualification) {
        this.data.edu_info.type_of_admission = 2;
        this.setAlternativeColleges = false;
        this.sendToParent.emit({alternativeColleges: [], setAlternativeColleges: this.setAlternativeColleges});
      } else {
        this.data.edu_info.type_of_admission = 1;
      }
      this.getColleges($event);
    }

  collegeChanged($event) {
    this.mainCollegeInfo = [];
    this.loadDisabledColleges();
    this.loadMainCollegeGSProfessionPlaceCountInfo();
  }

  private loadCenterProfessionInfo() {
    this._centerProfessionService.getById(this.data.entrance_info.speciality).subscribe(data => {
      this.data.entrance_info.specialExamProvided = data.specialExamProvided;
    });
  }

  specialExamTypeChanged() {
    this.data.entrance_info.specialExam = null;
    this.getSubjectsBallsCount('entrance_exams_info');
  }

  interviewSpecialExamTypeChanged() {
    this.data.edu_info.interview_info.interviewSpecialExam = null;
  }

  isFromEgov() {
    return this.isTechSecretary
        && this.data.fromEgov && this.applicationStatus == ApplicantStatusEnum.CONFIRMED_WITHOUT_DOCUMENTS
        && this.isUniversityWorker ? false : this.applicationFormDisabled;
  }

  isAlternativeSubjectDisabled(i, admission) {
    /*if (!this.data.isCurrentUserApplicant && this.isTechSecretary && this.isUniversityWorker
      && admission.subject && admission.subject.creativeExam
      && this.user && this.data && this.user.collegeId != this.data.collegeId) {
      return !(this.user.collegeId == this.alternativeColleges[i].collegeId);
    }*/
    return this.applicationFormDisabled;
  }

  logger() {
    console.log('data.entrance_info.payment_form == PaymentForm.FREE: ', this.data.entrance_info.payment_form == PaymentForm.FREE);
    console.log('applicationStatus == ApplicantStatusEnum.CONFIRMED_WITH_DOCUMENTS: ', this.applicationStatus == ApplicantStatusEnum.CONFIRMED_WITH_DOCUMENTS);
    console.log('applicationStatus: ', this.applicationStatus);
    console.log('isUniversityWorker : ', this.isUniversityWorker );
    console.log('isTechSecretary: ', this.isTechSecretary);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/enroll-cabinet/tabs/enroll-entrans-info/enroll-entrans-info.component.ts